<template>
  <v-carousel
    :height="height"
    hide-delimiter-background
    show-arrows-on-hover
    :hide-delimiters="true"
    :cycle="true"
    :continuous="continuous"
    v-if="slides"
  >
    <v-carousel-item v-for="(slide, i) in slides" :key="i">
      <v-sheet height="100%">
        <v-row class="fill-height" align="center" justify="center">
          <v-img :src="slide" :height="height" width="200"></v-img>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "CarouselImage",
  components: {},
  props: {
    slides: {
      default: null,
    },
    height: {
      default: "400",
    },
    cycle: {
      default: true,
    },
    continuous: {
      default: true,
    },
  },
})
export default class CarouselImage extends Vue {}
</script>